import { useMemo } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { RoomIdSessionId, useGetSessionsByIdsQuery } from '../../store/media/media'
import { parseMetadata } from '../../apps/professional-app/fa/MeetingSummary/utils'
import { ExternalUserConsentChange } from '../../models/User'

export const useMeetingTitles = (consentChanges: ExternalUserConsentChange[] | undefined) => {
  const accountId = useAppSelector(selectAccountId)

  const roomIdSessionIds = useMemo<RoomIdSessionId[]>(() => {
    if (!consentChanges) return []

    const seen = new Set<string>()
    return consentChanges
      .filter((c) => c.roomId && c.sessionId && !seen.has(`${c.roomId}|${c.sessionId}`) && seen.add(`${c.roomId}|${c.sessionId}`))
      .map((c) => ({ roomId: c.roomId!, sessionId: c.sessionId! }))
  }, [consentChanges])

  const { data: sessions } = useGetSessionsByIdsQuery({ accountId, body: { roomIdSessionIds } }, { skip: roomIdSessionIds.length === 0 })

  return useMemo<Record<string, string>>(() => {
    if (!sessions) return {}

    const map: Record<string, string> = {}
    for (const session of sessions) {
      const metadata = parseMetadata(session.metadata)
      map[session.id] = metadata?.external?.title ?? session.id
    }
    return map
  }, [sessions])
}
